<template>
  <div v-frag>
    <template v-if="$vuetify.breakpoint.mobile">
      <div style="border: thin solid rgba(0 0 0 / 0.12); padding: 8px">
        <div style="position: sticky; top: 0; font-weight: bold">
          {{ title }}
        </div>
        <slot></slot>
      </div>
    </template>
    <template v-else>
      <fieldset class="pa-3 rounded fs-border" :style="{ borderColor: color }">
        <legend v-if="title" class="px-2 black--text">
          <v-btn
            v-if="collapsible"
            outlined
            style="height: unset; min-width: unset"
            class="px-0 mr-2 fs-border"
            @click="toggle"
          >
            <v-icon>{{ expanded ? "mdi-minus" : "mdi-plus" }}</v-icon>
          </v-btn>
          <span v-if="collapsible" style="cursor: pointer" @click="toggle">
            {{ title }}
          </span>
          <span v-else>{{ title }}</span>
        </legend>
        <slot v-if="expanded"></slot>
      </fieldset>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "rgba(0 0 0 / 0.12)",
    },
  },
  data() {
    return {
      expanded: true,
    };
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped>
.fs-border {
  border: 1px solid rgba(0, 0, 0, 0.42);
}
</style>
